import {COVER_GALLERY_VERSION} from "../../../gd-components/cover/cover-selector/main/galery/gallery-items"
import {CoverType} from "../../../gd-components/cover/cover-type"

export enum CoverPosition {
    TOP     = 'top',
    MIDDLE  = 'middle',
    BOTTOM  = 'bottom'
}

export class Cover {

    public type     : CoverType
    public id       : ID                // is used for CoverType.GALLERY only
    public url      : string
    public thumbnail: string            // is used for CoverType.GALLERY only
    public position : CoverPosition

    constructor(data:any) {
        this.type       = _.get(data,'type', CoverType.LINK)
        this.id         = _.get(data,'id', '')
        this.url        = _.get(data,'url', '')
        this.thumbnail  = _.get(data,'thumbnail', '')
        this.position   = _.get(data,'position', CoverPosition.MIDDLE)
    }

    get backgroundPosition() {
        switch (this.position) {
            case CoverPosition.MIDDLE   : return 'center'
            case CoverPosition.BOTTOM   : return 'bottom'
            case CoverPosition.TOP      :
            default                     : return 'top'
        }
    }

    get backgroundImage() {
        switch (this.type) {
            case CoverType.GALLERY  : return 'url("/app/web/skin/common/covers/{0}?{1}")'.f(this.url, COVER_GALLERY_VERSION)
            default                 : return 'url("{0}")'.f(this.url)
        }
    }

    get backgroundThumbnailImage() {
        switch (this.type) {
            case CoverType.GALLERY  : return 'url("/app/web/skin/common/covers/{0}?{1}")'.f(this.thumbnail, COVER_GALLERY_VERSION)
            default                 : return 'url("{0}")'.f(this.thumbnail)
        }
    }

    toJSON() {
        return {
            type    : this.type,
            id      : this.id,
            url     : this.url,
            position: this.position,
        }
    }
}